// extracted by mini-css-extract-plugin
module.exports = {"gliderItem":"Slider_gliderItem__3vSHc","gliderItemTV":"Slider_gliderItemTV__2hBdJ"};